<template>
  <div class="card card-custom">
    <div class="card-body pb-5">
      <v-form class="form">
        <v-container>
          <v-row>
            <v-col cols="12" md="12">
              <h3>
                {{$t('upload.title')}}
              </h3>
              <p>
                {{$t('upload.desc1')}}
              </p>
              <p>{{$t('upload.desc2')}}</p>
              <FileDrop
                @updateFile="updateFile"
                :mimeTypes="[
                  'application/zip',
                  'application/vnd.rar',
                  'application/x-zip-compressed',
                  'application/x-zip',
                  'application/x-rar-compressed',
                  'application/x-rar',
                  'application/x-7z-compressed',
                  'application/x-7z',
                ]"
                mimeTypesSupported=".zip, .7z"
                :mimeError="$t('upload.mimeTypes')"
                :fileSizeMaxBytes="1000000000"
                fileSizeMax="1 Go"
                :fileSizeMaxError="$t('upload.fileMaxSizeError')"
              ></FileDrop>
            </v-col>
          </v-row>
        </v-container>
        <v-btn color="primary" class="mr-4 float-right" @click="submit">
          {{$t('upload.send')}}
        </v-btn>
      </v-form>
    </div>
    <!-- Dialog qui affiche la progress circular.
    Ne s'affiche que si loading = true -->
    <v-dialog v-model="loading" fullscreen full-width>
      <v-container
        fluid
        fill-height
      >
        <v-layout justify-center align-center>
          <v-progress-circular indeterminate color="pink">
          </v-progress-circular>
        </v-layout>
      </v-container>
    </v-dialog>
  </div>
</template>
<script>
import FileDrop from "@/components/files/FileDrop.vue";
import Api from "@/core/services/api.service";
import Swal from "sweetalert2";

export default {
  name: "formVideoUser",
  data: () => ({
    loading: false,
    file: null,
  }),

  components: {
    FileDrop,
  },

  methods: {
    updateFile(e) {
      this.file = e;
    },


    submit: async function() {
      this.loading = true;
      //On construit le formData pour y mettre les fichiers, qui seront envoyés seulement si la requête
      //Ci-dessus à fonctionné.
      // Pour rappel, on utilise FormData car on ne peut pas envoyer de media en JSON. (c'est du binaire)
      var bodyFormData = new FormData();

      bodyFormData.append("video", this.file);

      try {
        //Dans l'API, on a crée une route spécialement pour pouvoir recevoir du formdata avec des fichiers
        //et pouvoir les traiter. (Voir documentation API Platform FormData)

        await Api.post(`video_to_uploads`, bodyFormData);
        this.loading = false;
        //On stop le progress circular
        this.$router.push({ name: "tableauDeBord" });
        //router.push redirection

        //Une fois que les 2 requêtes ont réussis
        Swal.fire({
          //Swal = Sweet Alert
          title: "",
          text: "Ton contenu a bien été envoyé",
          icon: "success",
          confirmButtonClass: "btn btn-secondary",
        });
      } catch (error) {
        //En cas d'erreur, on ferme le progress circular
        this.loading = false;
        Swal.fire({
          title: "",
          text:
            "Une erreur est survenue lors de l'envoi de votre archive, veuillez réessayer",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
        });
      }
    },
  },
};
</script>
